import { api } from './api';

export const tablesListApi = params => {
  return api.get('/pos/fetch-tables');
};

export const fetchSingleTable = params => {
return api.post('/pos/fetch-single-table', JSON.stringify(params));
};

export const tableDetailsApi = params => {
  return api.post('/pos/fetch-table-products', JSON.stringify(params));
};

export const fetchGroupProducts = params => {
return api.post('/pos/fetch-group-products', JSON.stringify(params));
};

export const tableAddOrdersApi = params => {
  return api.post('/pos/add-table-products', JSON.stringify(params));
};

export const tableEditOrdersApi = params => {
  return api.post('/pos/edit-table-products', JSON.stringify(params));
};

export const productListApi = params => {
  return api.get('/pos/fetch-products');
};

export const checkoutApi = params => {
  return api.post('/pos/checkout', JSON.stringify(params));
};

export const fetchOrderForCheckoutApi = params => {
  return api.post('/pos/fetch-order-for-checkout', JSON.stringify(params));
};

export const parcelOrderProducts = params => {
  return api.post('/pos/parcel-order-products', JSON.stringify(params));
};

export const pastOrderListApi = params => {
  return api.post('/pos/past-order-list');
};

export const pastOrderDetailsApi = params => {
  return api.post('/pos/past-order-details', JSON.stringify(params));
};


export const clearTableProductsApi = params => {
  return api.post('/pos/clear-table-products', JSON.stringify(params));
};